/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Pol_Verified_AllInputs */

const en_pol_verified_all = /** @type {(inputs: Pol_Verified_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last checked ${i?.date}`)
};

const id_pol_verified_all = /** @type {(inputs: Pol_Verified_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Terakhir dicek ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Last checked {date}" |
*
* @param {Pol_Verified_AllInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_verified_all = /** @type {((inputs: Pol_Verified_AllInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Verified_AllInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_verified_all(inputs)
	return en_pol_verified_all(inputs)
});